import _ from "lodash";
import PGSHelper from "../../helpers/PGSHelper";

export default class VentasInsumo {
  static getDocData(mainData) {
    // cuerpo de la tabla de insumos
    const tableBody = this.getTable(mainData.data);

    return {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",

      content: [
        // Título centrado
        {
          text: mainData.TITLE,
          style: "header",
        },

        // sección de fechas / generación como mini-tabla sin bordes
        {
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  text: `De: ${mainData.FF}\nHasta: ${mainData.FU}`,
                  bold: true,
                },
                {
                  text: `Generado: ${mainData.FG}\nHora: ${mainData.HG}`,
                  alignment: "right",
                  bold: true,
                },
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 10],
        },

        // tabla principal de insumos
        {
          table: {
            headerRows: 1,
            widths: ["*", "*"],
            body: tableBody,
          },
        },
      ],

      styles: {
        header: {
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
      },
    };
  }

  static getTable(data) {
    const headers = [
      {
        text: "Insumo",
        bold: true,
        fontSize: 12,
        alignment: "center",
        border: [true, true, true, true],
      },
      {
        text: "Cantidad total",
        bold: true,
        fontSize: 12,
        alignment: "center",
        border: [true, true, true, true],
      },
    //   {
    //     text: "Folios ventas",
    //     bold: true,
    //     fontSize: 12,
    //     alignment: "center",
    //     border: [true, true, true, true],
    //   },
    ];

    let helper = new PGSHelper();
    const body = [headers];

    data.forEach((prod) => {
      const foliosText = (prod.insumoVentas || []).length
        ? prod.insumoVentas.join("\n")
        : "-";

      body.push([
        {
          text: prod.Nombre,
          fontSize: 11,
          alignment: "left",
          border: [true, false, true, true],
        },
        {
          text: `${helper.formatNumber(prod.TotalCantidad)} ${prod.UM}`,
          fontSize: 11,
          alignment: "center",
          border: [true, false, true, true],
        },
        // {
        //   text: foliosText,
        //   fontSize: 11,
        //   alignment: "center",
        //   border: [true, false, true, true],
        // },
      ]);
    });

    return body;
  }
}
